import CustomHttpService from './custom-http.service';
import EncodeDecodeType from '../actiontype/encode-decode-type';
import Config from '../config/config';

export default class AuthService {
    //Check if user is logged in or not
    static checkIfUserLoggedIn() {
        let url = Config.baseUrls.ONLINE.DIGITAL_PROFILE_CONTEXT_URI + "customer/profile/unauth/v1/get/login/info";
        return CustomHttpService.get(url, {}, EncodeDecodeType.HELPSUPPORT);
    }

    //Check user
    static checkUser(userId) {
        const data = {
            "userid": userId
        }
        let url = Config.baseUrls.ONLINE.DIGITAL_PROFILE_CONTEXT_URI + "customer/authapp/v1/checkuser";
        return CustomHttpService.post(url, data, {}, EncodeDecodeType.ONLINE);
    }

    //generate otp
    static generateOtp(requestkey) {
        const data = {
            "requestkey": requestkey
        }
        let url = Config.baseUrls.ONLINE.DIGITAL_PROFILE_CONTEXT_URI + "customer/authapp/v1/generateotp";
        return CustomHttpService.post(url, data, {}, EncodeDecodeType.ONLINE);
    }

    // //validate otp
    // static validateOtp(requestkey, enteredOtp) {
    //     const data = {
    //         "requestkey": requestkey,
    //         "otp": enteredOtp
    //     }
    //     let url = Config.baseUrls.ONLINE.DIGITAL_PROFILE_CONTEXT_URI + "customer/authapp/v1/validateuserwithotp";
    //     return CustomHttpService.post(url, data, {}, EncodeDecodeType.ONLINE);
    // }

    //validate otp
    static validateOtp(requestkey, enteredOtp) {
        const data = {
            "requestkey": requestkey,
            "otp": enteredOtp
        }
        let url = Config.baseUrls.ONLINE.DIGITAL_PROFILE_CONTEXT_URI + "customer/authapp/v2/validateotp";
        return CustomHttpService.post(url, data, {}, EncodeDecodeType.ONLINE);
    }

    //auth login
    static authLogin(requestkey) {
        const data = {
            "requestkey": requestkey
        }
        let url = Config.baseUrls.ONLINE.DIGITAL_PROFILE_CONTEXT_URI + "customer/authapp/v1/authloginget?requestkey=" + data.requestkey;
        return CustomHttpService.get(url, {}, EncodeDecodeType.ONLINE);
    }

    // //fetch user details
    // static fetchSSOProfile() {
    //     let url = Config.baseUrls.HELPSUPPORT.HELPSUPPORT_CONTEXT_URI + "customer/help/support/v1/rtn/fetch";
    //     return CustomHttpService.get(url, {}, EncodeDecodeType.HELPSUPPORT);
    // }

    //fetch user details
    static fetchSSOProfile() {
        let url = Config.baseUrls.ONLINE.DIGITAL_PROFILE_CONTEXT_URI + "customer/profile/v2/rtn/fetch";
        return CustomHttpService.get(url, {}, EncodeDecodeType.HELPSUPPORT);
    }

    //logout 
    static logout() {
        const logOutLink = "https://www.airtel.in/pkmslogout?redirectURL=https://www.airtel.in/help?source=loginagain";
        window.open(logOutLink, "_self");
    }

}